import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { CountdownPricing } from './components/CountdownPricing';
import { PackComparison } from './components/PackComparison';
import { MoreTestimonials } from './components/MoreTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalComparison } from './components/FinalComparison';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel - direct injection
    const pixelId = '1904779843432668';
    if (!(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      (window as any).fbq('init', pixelId);
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-brandGreen selection:text-navy" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <Testimonials data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ProductOverview data-id="element-5" />
      <Tomos data-id="element-6" />
      <Bonuses data-id="element-7" />
      <CountdownPricing data-id="element-8" />
      <PackComparison data-id="element-9" />
      <MoreTestimonials data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      <FinalComparison data-id="element-13" />
      <CountdownPricing data-id="element-14" /> {/* Reusing for Final CTA as requested */}
      <Footer data-id="element-15" />
    </div>;
}